import { render, staticRenderFns } from "./spareGetDetail.vue?vue&type=template&id=4c6bb5d8&scoped=true"
import script from "./spareGetDetail.vue?vue&type=script&lang=js"
export * from "./spareGetDetail.vue?vue&type=script&lang=js"
import style0 from "./spareGetDetail.vue?vue&type=style&index=0&id=4c6bb5d8&prod&lang=css"
import style1 from "./spareGetDetail.vue?vue&type=style&index=1&id=4c6bb5d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6bb5d8",
  null
  
)

export default component.exports